import * as fromDatatype from "../datatype-library/index";

export interface bl_sfa_qualification_criteria_link_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	target_type: fromDatatype.VarcharDatatypeInterface;
	target_guid: fromDatatype.GuidDataFieldInterface;
	qualification_criteria_guid: fromDatatype.GuidDataFieldInterface;
	link_type: fromDatatype.VarcharDatatypeInterface;
	value_string: fromDatatype.VarcharDatatypeInterface;
	value_numeric: fromDatatype.NumericDatatypeInterface;
	value_boolean: boolean;
	value_datetime: fromDatatype.TimestampTzDatatypeInterface;
	value_json: fromDatatype.JsonDatatypeInterface;
	value_file: fromDatatype.VarcharDatatypeInterface;
	value_text: fromDatatype.TextDatatypeInterface;
	value_array: fromDatatype.VarcharArrayDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_sfa_qualification_criteria_link_RowClass
	implements bl_sfa_qualification_criteria_link_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	target_type: fromDatatype.VarcharDatatypeInterface;
	target_guid: fromDatatype.GuidDataFieldInterface;
	qualification_criteria_guid: fromDatatype.GuidDataFieldInterface;
	link_type: fromDatatype.VarcharDatatypeInterface;
	value_string: fromDatatype.VarcharDatatypeInterface;
	value_numeric: fromDatatype.NumericDatatypeInterface;
	value_boolean: boolean;
	value_datetime: fromDatatype.TimestampTzDatatypeInterface;
	value_json: fromDatatype.JsonDatatypeInterface;
	value_file: fromDatatype.VarcharDatatypeInterface;
	value_text: fromDatatype.TextDatatypeInterface;
	value_array: fromDatatype.VarcharArrayDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
